import Slice from "./Slice";
export const { showUserErrorAction, hideErrorAction } = Slice.actions;
